import React from 'react';
import { MessageCircle } from 'lucide-react';
import { WHATSAPP_URL } from '../lib/contact';
export function FloatingWhatsApp() {
  return <a href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer" aria-label="Hablá conmigo por WhatsApp" className="fixed bottom-6 right-6 z-50 flex items-center gap-3 bg-[#25D366] text-white rounded-full pl-4 pr-5 py-3.5 shadow-[0_10px_30px_-5px_rgba(37,211,102,0.6)] hover:scale-105 active:scale-95 transition-transform duration-300" data-id="element-184">
      <MessageCircle size={26} className="shrink-0" data-id="element-185" />
      <span className="hidden sm:inline font-bold text-sm whitespace-nowrap" data-id="element-186">
        Hablá conmigo por WhatsApp
      </span>
    </a>;
}